<template>
  <v-container grid-list-sm text-xs-left>

    <v-layout row wrap pa-2 align-end>
      <v-flex>
        <v-flex>
          <span class="title_style">{{ TeC.introduction.title }}</span>
        </v-flex>
        <v-flex>
          <v-flex class="justify_text" v-for="part in TeC.introduction.parts">
            <span class="text_style">{{ part }}</span>
          </v-flex>
          <br>
          <br>
        </v-flex>
        <v-flex>
          <ol>
            <li v-for="chap in TeC.chapters">
              <v-flex>
                <span class="title_style">{{ chap.title }}</span>
              </v-flex>
              <v-flex class="justify_text" v-for="part in chap.parts">
                <span class="text_style">{{ part }}</span>
              </v-flex>
              <br>
              <br>
            </li>
          </ol>
        </v-flex>



      </v-flex>

    </v-layout>
  </v-container>


</template>

<script>
import TeCJson from './TeC.json'
import {convertLineBreak} from "@/utils/stringHandling";

export default {
  name: "TeCPage",
  components: {},
  data() {
    return {
      TeC: TeCJson

    }
  },
  created() {
    this.TeC = convertLineBreak(this.TeC);
  },
}

</script>

<style scoped lang="scss">
.text_style {
  font-size: 19px;
}

.title_style {
  font-size: 34px;
  font-weight: bold;
}

::marker {
  font-size: 34px;
  font-weight: bold;
}

.justify_text {
  text-align: justify;
}

</style>
